<script setup>
defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<template>
  <div class="triple-block row-130-25 p-top-l-1 max">
    <div class="section-triple-block">
      <!-- eslint-disable vue/no-v-html -->
      <div v-if="block.length" class="container">
        <div v-for="servizio in block" :key="servizio.id" class="block">
          <div class="content">
            <DefaultPicture
              :image="{ custom: servizio.immagine.responsiveImage }"
              :lazy-load="true"
              alt="Istituto Canossiano"
            />
            <div class="title-base2 title" v-html="servizio.titolo" />
            <p class="text-s-1-b" v-html="servizio.testo" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TripleBlock',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
